"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  nativeCurrencyCode: 'USD',
  bookableCurrencies: [{
    symbol: '$',
    code: 'USD',
    name: 'U.S. Dollar',
    locale: 'en-US'
  }, {
    symbol: '$',
    code: 'CAD',
    name: 'Canadian Dollar',
    locale: 'en-CA'
  }, {
    symbol: '€',
    code: 'EUR',
    name: 'Euro',
    locale: 'en-GB'
  }],
  nonBookableCurrencies: [{
    symbol: '$',
    code: 'MXN',
    name: 'Mexican Peso',
    locale: 'es-MX'
  }]
};
exports["default"] = _default;